/** @format */

import { Button, Col, Form, Input, Row } from "antd";
import { FormProps } from "antd/lib/form";
import HiddenUsernameFormitem from "../../../components/HiddenUsernameFormItem";
import { InputProps } from "antd/lib/input";
import React from "react";

interface IProps {
	disableCreate: boolean;
	newPassword?: string;
	onChangeNewPassword: InputProps["onChange"];
	onChangeRetypedNewPassword: InputProps["onChange"];
	onClickCreate: FormProps["onFinish"];
	retypedNewPassword?: string;
}

function CreatePasswordFormView(props: IProps) {
	const [form] = Form.useForm();

	return (
		<Form form={form} onFinish={props.onClickCreate}>
			<HiddenUsernameFormitem />
			<Row>
				<Col>
					<Row>
						<Col>
							<Form.Item label="New password">
								<Input
									autoComplete="new-password"
									onChange={props.onChangeNewPassword}
									type="password"
									value={props.newPassword}
								/>
							</Form.Item>
						</Col>
					</Row>
					<Row>
						<Col>
							<Form.Item label="Retype new password">
								<Input
									autoComplete="new-password"
									onChange={props.onChangeRetypedNewPassword}
									type="password"
									value={props.retypedNewPassword}
								/>
							</Form.Item>
						</Col>
					</Row>
					<Row>
						<Col>
							<Form.Item>
								<Button
									block
									disabled={props.disableCreate}
									htmlType="submit"
									type="primary">
									Create
								</Button>
							</Form.Item>
						</Col>
					</Row>
				</Col>
			</Row>
		</Form>
	);
}

export default CreatePasswordFormView;
